module.exports = __webpack_public_path__ + "img/app-screenshot_2x.c02a972f.png";